
if($("#insta-feed")){
  
	$("#insta-feed").bind("DOMSubtreeModified", function() {
	   
	  if( $("#insta-feed").attr("data-animation") != "Value" ){
	   
	    swap();
	    
	  }
	
	});
	  
}

function swap(){

  $(".instafeed-container img").each(function(){
  
    if(!$(this).parent().hasClass("a")){
      
      $(this).parent().css({
    	"background": "url(" + $(this).attr("data-src") + ") center/cover"
  	  });
      
      $(this).parent().addClass("a");
      $(this).css("opacity",0);
      
     }
  
  });
  
}

	$(window).on("scroll", function(){
      
	  
	  if($(window).width > 700){
	
		var x = $(window).scrollTop()/10
	
		$(".instafeed-container").each(function(i){
	
			if (i % 2 == 1) { 
	
				$(this).css({
					"background-position-x": x
				});
	
			}else{
	
				$(this).css({
					"background-position-x": x*-1
				});
	
			}
	
		});
	
	   }
	  
	});

if( $("#insta-feed").attr("data-animation") == "Horizontal"){
  
  console.log("Horizontal")

	$(window).on("scroll", function(){
      
	  if($(window).width() > 700){
	
		var x = $(window).scrollTop()/10
	
		$(".instafeed-container").each(function(i){
	
			if (i % 2 == 1) { 
	
				$(this).css({
					"background-position-x": x
				});
	
			}else{
	
				$(this).css({
					"background-position-x": x*-1
				});
	
			}
	
		});
	
	   }
	  
	});
}

if( $("#insta-feed").attr("data-animation") == "Vertical"){

  	console.log("Vertical")
    
	$(window).on("scroll", function(){
	  
	  if($(window).width() > 700){
	
		var x = $(window).scrollTop()/10
	
		$(".instafeed-container").each(function(i){
	
			if (i % 2 == 1) { 
	
				$(this).css({
					"background-position-Y": x
				});
	
			}else{
	
				$(this).css({
					"background-position-Y": x*-1
				});
	
			}
	
		});
	
	   }
	  
	});
}